








import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component
export default class AppWrapper extends Vue {
    @Prop() lang: string;
    @Prop({ default: false }) isdevelopment: boolean;

    created() {
        this.initLang();
        this.$store.commit('setDevelopment', this.isdevelopment);
    }

    private initLang() {
        let lang = (this.$route && this.$route.params.lang) || this.lang;
        if (lang && lang != this.$store.state.lang) {
            this.$store.commit('setLang', lang);
            if (this.$i18n) {
                this.$i18n.locale = lang;
            }
        }
    }

    @Watch('$route')
    routeChanged(newValue: Route, oldValue: Route) {
        this.initLang();
    }

    get themeClasses() {
        let classes = ["page"];
        let theme = this.$store.state.theme;
        if (theme) {
            for (let k in theme) {
                classes.push(`${k}-${theme[k]}`);
            }
        }
        return classes;
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/dndg/components/app-wrapper.vue